import { useMatchingContext } from '@context/Matching';
import { useEffect, useLayoutEffect } from 'react';
import { useBackHandlerContext } from '@context/BackHandler';

import * as styles from './styles';

import Instruction from './components/Instruction';

const MatchingView = () => {
  const { checkDoctorMatching, checkMatchingEnd, openCancelTreatemtnModal } =
    useMatchingContext();

  useEffect(checkDoctorMatching, [checkDoctorMatching]);
  useEffect(checkMatchingEnd, [checkMatchingEnd]);

  const { addCallback } = useBackHandlerContext();

  useLayoutEffect(() => {
    return addCallback(() => {
      openCancelTreatemtnModal();
      return false;
    });
  }, [addCallback, openCancelTreatemtnModal]);

  return (
    <div>
      <div css={styles.backgroundImage}></div>
      <div css={styles.container}>
        <Instruction />
      </div>
    </div>
  );
};

export default MatchingView;
